<ng-content></ng-content>
<span class="position-absolute ml-1" *ngIf="sortDirection === 'asc'">
  &#8593;
</span>
<span class="position-absolute ml-1" *ngIf="sortDirection === 'desc'">
  &#8595;
</span>
